module.exports = __webpack_public_path__ + "img/icon-consent-cookie.3ef5d51f.svg";